import { RECEIVE_AWARDS_DATA } from "../actions/awardsActions";

const initialState = {};

export default function awardsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_AWARDS_DATA:
      return {
        ...state,
        awards: [...action.payload]
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/awardsReducer.js